module.exports = __webpack_public_path__ + "img/DE00573.3a6051f4.png";